// aikka OS signal mark — ported verbatim from ../aikka-os/client/src/components/logo.tsx.
// Namespaced under @os because src/studio/components/AikkaMark.tsx already owns
// the name `AikkaMark` for the (frozen) mockup shell.
export function AikkaMark({ size = 22, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-label="aikka signal mark"
      className={className}
    >
      <circle cx="16" cy="16" r="2.6" className="fill-signal" />
      <g stroke="currentColor" strokeWidth="1.15" opacity="0.9" strokeLinecap="round">
        <line x1="16" y1="12.6" x2="16" y2="4.5" />
        <line x1="16" y1="19.4" x2="16" y2="27.5" />
        <line x1="12.6" y1="16" x2="4.5" y2="16" />
        <line x1="19.4" y1="16" x2="27.5" y2="16" />
        <line x1="13.7" y1="13.7" x2="8" y2="8" />
        <line x1="18.3" y1="18.3" x2="24" y2="24" />
        <line x1="13.7" y1="18.3" x2="8" y2="24" />
        <line x1="18.3" y1="13.7" x2="24" y2="8" />
        <line x1="16" y1="12.6" x2="20.2" y2="6.1" opacity="0.45" />
        <line x1="16" y1="12.6" x2="11.8" y2="6.1" opacity="0.45" />
        <line x1="16" y1="19.4" x2="20.2" y2="25.9" opacity="0.45" />
        <line x1="16" y1="19.4" x2="11.8" y2="25.9" opacity="0.45" />
      </g>
    </svg>
  );
}

/**
 * The lockup is artwork, never type. The wordmark used to be a `<span>aikka</span>`
 * in the UI face, which meant the logo changed shape every time the body font
 * changed — brand v4 forbids typesetting it outright. It is now the supplied
 * lockup PNG, with `alt=""` because the surrounding link already carries the
 * accessible name.
 *
 * `variant="white"` is for the dark CTA bands only; everything else is ink on
 * cream.
 *
 * The lockup is a monochrome ink PNG, so `currentColor` can't tint it: on a dark
 * OS surface the ink artwork would vanish. The stable `aikka-logo` hook plus
 * `data-variant` lets os.css flip the ink lockup to white in the dark theme
 * (DESIGN.md §4 — `*-white` reverse variant), while the explicit `white` variant
 * used on marketing CTA bands is left untouched.
 */
export function AikkaLogo({
  className = '',
  variant = 'ink',
  height = 26,
}: {
  className?: string;
  variant?: 'ink' | 'white';
  height?: number;
}) {
  return (
    <span className={`aikka-logo inline-flex items-center ${className}`} data-variant={variant}>
      <img
        src={variant === 'white' ? '/img/brand/lockup_white.png' : '/img/brand/lockup_ink.png'}
        alt=""
        height={height}
        style={{ height, width: 'auto' }}
        className="block select-none"
        draggable={false}
      />
    </span>
  );
}
